import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

import { Section } from '../../components/Section';
import Customer from '../../components/NewCustomer/Customer';
import EnterpriseRegistration from '../../components/Registration/Enterprise';
import Styles from './Registration.module.scss';
import BaseLayout from '../../components/Layout/BaseLayout';

const EnterpriseRegisterPage = ({ ...props }) => {
  const router = useRouter();
  useEffect(() => {
    const intercomElement = document.querySelector('#intercom-container');
    if (intercomElement) {
      intercomElement.classList.add('intercom-hidden');
    }
  }, []);

  const pageHead = {
    title: `Access to Top Marketing, Creative and Digital Talents and Teams | ${process.env.NEXT_PUBLIC_SITE_NAME}`,
    meta: [
      {
        name: 'description',
        content: `Scale your marketing, creative and digital initiatives with ${process.env.NEXT_PUBLIC_SITE_NAME}'s exclusive talent network. Rigorously screened for your most important projects.`,
      },
    ],
  };

  return (
    <BaseLayout pageHead={pageHead} removeMetaImage removeMetaSocial removeMetaJsonLd>
      <div className={Styles.containerEnterprise}>
        <Section>
          <EnterpriseRegistration query={router.query} />
          <div className={Styles.bottom}>
            <Customer />
          </div>
        </Section>
      </div>
    </BaseLayout>
  );
};

export default EnterpriseRegisterPage;
